// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  patchId: __t.u64().primaryKey().name("patch_id"),
  worldId: __t.u64().name("world_id"),
  patchKey: __t.string().name("patch_key"),
  value: __t.string(),
  version: __t.u32(),
  updatedBy: __t.identity().name("updated_by"),
  updatedAt: __t.timestamp().name("updated_at"),
});
